import type { AdminHttpClient } from './client.js';

export function withUnauthorizedRetry(
  http: AdminHttpClient,
  renew: () => Promise<void>
): AdminHttpClient {
  return new Proxy(http, {
    get(target, prop, receiver) {
      const value = Reflect.get(target, prop, receiver);
      if (typeof value !== 'function') return value;
      return async (...args: unknown[]) => {
        try {
          return await value.apply(target, args);
        } catch (error) {
          if (!isUnauthorized(error)) throw error;
          await renew();
          return await value.apply(target, args);
        }
      };
    },
  }) as AdminHttpClient;
}

export function withUnauthorizedLogout(
  http: AdminHttpClient,
  logout: () => void
): AdminHttpClient {
  return new Proxy(http, {
    get(target, prop, receiver) {
      const value = Reflect.get(target, prop, receiver);
      if (typeof value !== 'function') return value;
      return async (...args: unknown[]) => {
        try {
          return await value.apply(target, args);
        } catch (error) {
          if (isUnauthorized(error)) logout();
          throw error;
        }
      };
    },
  }) as AdminHttpClient;
}

function isUnauthorized(error: unknown): boolean {
  return Boolean(
    error &&
      typeof error === 'object' &&
      'status' in error &&
      (error as { status: unknown }).status === 401
  );
}
